import { blockManifestReader } from "../internal/read-block-manifest.js";
/**
 * Returns some very basic info about blocks in the project.
 * This is purposely lean, to avoid bloated info.
 */
export function getPublicBlockInfo() {
    return blockManifestReader.info;
}
/**
 * Takes raw content blocks from GraphQL, and adds flags to them.
 * This is used by InnerBlocks, ContentBlocks and useInnerBlocks.
 *
 * Note that this function mutates the existing block, adding new properties.
 */
export function addBlockMetadata(blocks) {
    const out = (blocks ?? []);
    const infos = getPublicBlockInfo();
    for (let block of out) {
        if (!block)
            continue;
        const info = infos[block.blockName];
        block.tags = info?.tags ?? [];
        block.flags = info?.flags ?? {};
        block.slug = (info?.slug ?? block.blockName);
        if (block.innerBlocks && block.innerBlocks.length) {
            addBlockMetadata(block.innerBlocks);
        }
    }
    return out;
}
export function getBlockMetadata(blockName) {
    const infos = getPublicBlockInfo();
    const info = infos[blockName];
    if (!info)
        return {
            slug: blockName,
        };
    return {
        tags: info.tags,
        flags: info.flags,
        slug: info.slug,
    };
}
